import { useMutation } from '@tanstack/react-query'
import { useToast } from 'src/shared/hooks/use-toast'
import { useLocalization } from 'src/shared/hooks/useLocalization'

import { ServerRoutes } from './serverRoutes'

interface SendEmailProps {
  toEmails: string[]
  subject: string
  message: string
  html?: string
}

export const useSendEmail = () => {
  const toast = useToast()
  const { t } = useLocalization()

  return useMutation({
    mutationFn: async (props: SendEmailProps) => {
      const response = await fetch(
        import.meta.env.VITE_BE_SERVER_URL + ServerRoutes.sendEmail,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            toEmails: props.toEmails,
            subject: props.subject,
            message: props.message,
            html: props.html,
          }),
        }
      )

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(
          errorData.msg || t('Failed to send email', 'Kunde inte skicka e-post')
        )
      }

      return await response.json()
    },
    onError: (error: Error) => {
      toast.toast({
        title: t('Something went wrong', 'Något gick fel'),
        description: error.message,
        variant: 'destructive',
        duration: 5000,
      })
    },
  })
}
